<template>
  <div class="notification_rail">
    <transition-group name="list-complete" tag="div" v-on:enter="enter">
      <Notification
        class="notification_rail__notification"
        v-for="notification in notificationList"
        :key="`notification-${notification.id}`"
        :type="notification.type"
        :message="notification.message"
        :actionName="notification.actionName"
        :customTitle="notification.customTitle"
        :action="notification.action"
        :labelClose="labelClose"
        v-on:requestClose="requestNotificationClose(notification.id)"
      ></Notification>
    </transition-group>
  </div>
</template>

<script>
import BaseComponent from "../BaseComponent";
import Notification from "../molecules/Notification.vue";

/**
 * @group Notifications
 * This shows and orders the notifications. You can pass it an array of Notification Objects.
 * Then it will show it for an x amount of time and hide it after.
 * To use this properly you should use the /stores/notifcationStore.js store include.
 */
export default {
  name: "NotificationRail",
  mixins: [BaseComponent],
  components: {
    Notification,
  },
  props: {
    /**
     * @vuese
     * Array of Notification Objects, see notificationStore.js for documentation on that.
     */
    notificationList: {
      required: true,
      type: Array,
    },
    labelClose: {
      type: String,
      default: "Close",
    },
  },
  methods: {
    enter(parsedElement) {
      const element = parsedElement;
      // Lock position
      if (!element.previousElementSibling) return;
      element.style.top = `
                ${
                  element.previousElementSibling.offsetTop +
                  element.previousElementSibling.offsetHeight +
                  12
                }px`;
      element.style.position = "absolute";
    },
    requestNotificationClose(id) {
      this.$store.commit("removeNotification", id);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../style_variables/style_variables.scss";
.notification_rail {
  position: fixed;
  width: 364px;
  z-index: 20000;
  top: 0px;
  right: 0px;
}
.notification_rail__notification {
  margin-bottom: 12px;
  transition: all 1s;
  margin-right: 10px;
  overflow: hidden;
  position: relative;
}

.notification_rail__notification {
  transition: all 1s;
}
.list-complete-enter {
  transform: translate(100%);
}
.list-complete-leave-active {
  transform: translate(110%);
}
</style>
